import Client from "@/http/client";
import {
  CustomerFeedbackCreateDto,
  CustomerFeedbackDto,
  CustomerFeedbackListDto,
} from "@/http/dto/customerFeedback";

export class CustomerFeedback {
  static create(hotelObjectId: string, input: CustomerFeedbackCreateDto) {
    return Client.post<CustomerFeedbackDto>(`/v2/${hotelObjectId}/feedback`, input);
  }

  static list(hotelObjectId: string, page = 1, take = 20) {
    return Client.get<CustomerFeedbackListDto>(`/v2/${hotelObjectId}/feedback`, { page, take });
  }

  static detail(hotelObjectId: string, feedbackObjectId: string) {
    return Client.get<CustomerFeedbackDto>(`/v2/${hotelObjectId}/feedback/${feedbackObjectId}`);
  }

  static addMessage(hotelObjectId: string, feedbackObjectId: string, contents: string) {
    return Client.post<CustomerFeedbackDto>(
      `/v2/${hotelObjectId}/feedback/${feedbackObjectId}/messages`,
      { contents },
    );
  }
}
